import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {timeFormat} from 'd3-time-format'
import {Modal, Alert} from 'antd'

@inject('store') @observer
class UnsubscribeModal extends Component {
  unsubscribe = async () => {
    await this.props.store.subscription.unsubscribe()
    this.props.handleCancel()
  }

  render() {
    const {visible} = this.props
    const {next_payment_at} = this.props.store.user.data.account
    const {loading} = this.props.store.subscription
    return(
      <Modal
        visible={visible}
        onOk={this.unsubscribe}
        onCancel={this.props.handleCancel}
        okText='Cancel Subscription'
        cancelText='Return'
        confirmLoading={loading}
      >
        <Alert
          description={
            <p>
              By canceling the subscription, your account will be restricted at the end of this billing cycle on {' '}
              <b>{timeFormat('%b %d %Y')(new Date(next_payment_at))}</b> and you are going to lose your saved Algorithms. Are you sure you want to continue?
            </p>
          }
          type='warning'
          showIcon
        />
      </Modal>
    )
  }
}

export default UnsubscribeModal
